import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    direction: 'rtl',
    palette: {
        mode: 'light',
        primary: {
            main: '#5e806d',
            dark: '#4c6b59',
            light: '#d9e2dd',
            contrastText: '#ffffff',
        },
        error: {
            main: '#d32f2f',
            dark: '#b71c1c',
        },
        success: {
            main: '#27ae60',
        },
        background: {
            default: '#f4f6f5',
            paper: '#ffffff',
        },
        text: {
            primary: '#1f2937',
            secondary: '#64748b',
        },
        divider: '#d9e2dd',
    },
    shape: {
        borderRadius: 8,
    },
    typography: {
        fontFamily: 'vazir, sans-serif',
        button: {
            textTransform: 'none',
            fontWeight: 600,
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 8,
                    minHeight: 40,
                },
                contained: {
                    boxShadow: 'none',
                    '&:hover': {
                        boxShadow: 'none',
                    },
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                rounded: {
                    borderRadius: 12,
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    borderColor: '#eee',
                },
            },
        },
        MuiDialog: {
            styleOverrides: {
                paper: {
                    borderRadius: 12,
                },
            },
        },
    },
});

export default theme;
